<div class="columns" style="margin-left: 5%; margin-top: 1%;">
  <div class="column">
    <div class="info-box">
      <div class="tech-image" style="width:150px">
        <img src="https://angular.io/assets/images/logos/angular/angular.svg" alt="">
      </div>
    </div>
  </div>
  <div class="column">
    <div class="info-box">
      <div class="tech-image" style="width:210px">
        <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/1280px-React-icon.svg.png" alt="">
      </div>
    </div>
  </div>
  <div class="column">
    <div class="info-box">
      <div class="tech-image" style="width:140px" >
        <img src="https://img.icons8.com/color/452/mongodb.png">
      </div>
    </div>
  </div>
  <div class="column">
    <div class="info-box">
      <div class="tech-image" style="width:120px">
        <img src="https://seeklogo.com/images/N/nodejs-logo-FBE122E377-seeklogo.com.png" alt="">
      </div>
    </div>
  </div>
</div>
